module.exports = __webpack_public_path__ + "img/prize-05.d20f6560.png";